import ItemModel from "../../../components/items/model/item";
import {
    ADD_ITEM_FAILIRE, ADD_ITEM_REQUEST, ADD_ITEM_SUCCESS,
    SEARCH_ITEM_FAILIRE, SEARCH_ITEM_REQUEST, SEARCH_ITEM_SUCCESS,
    DELETE_ITEM_SUCCESS, FILTER_NO_CATEGORY, FILTER_NO_COVER, FILTER_NO_BARCODE, FILTER_NO_INTERNAL_ID
} from "../../ActionType/ActionType";
import {storage, firestore} from "../../../config/firebaseConfig"
import {toast} from "react-toastify";
import {itemsCollection, keywordsCollection} from "../../../constant/firestore";
import {isNot} from "../../../shared/functions/types_check";
import {uniqBy, isArray, orderBy} from 'lodash'
import {selectItems, selectProduct, setSnap} from "../../slices/item";
import {selectKeyword} from "../../slices/keyword.slice";


export const AddItem = (Item = new ItemModel(), goback, file = null) => {
    return (dispatch, getState, {getFirebase}) => {

        dispatch({type: ADD_ITEM_REQUEST})

        let d = new Date()

        if (file !== null) {
            let typ = file.type;
            let sp = typ.split('/')
            let ex = sp[1]
            let n = Item.Barcode + "." + ex;

            const up = storage.ref(`images/${n}`).put(file);

            up.on('state_changed', (snap) => {

                }, error => toast.error(error),
                () => {
                    storage.ref('images').child(`${n}`).getDownloadURL().then(url => {
                        Item.ImageUrl = url

                        getFirebase().firestore().collection("items").add({
                            ...Item,
                            CreateAt: d,
                            PriceUpdateAt: d,
                            UpdateAt: d,
                            ImageUrl: url
                        })
                            .then((result) => {
                                dispatch({type: ADD_ITEM_SUCCESS});
                                goback();
                            })
                            .catch((error) => {
                                dispatch({type: ADD_ITEM_FAILIRE, error})
                            })
                    })


                })

        } else {

            getFirebase().firestore().collection("items").add({...Item, CreateAt: d, PriceUpdateAt: d, UpdateAt: d})
                .then((result) => {
                    dispatch({type: ADD_ITEM_SUCCESS});
                    goback();
                })
                .catch((error) => {
                    dispatch({type: ADD_ITEM_FAILIRE, error})
                })
        }
    }
}


export const UpdateItem = (Itemm, goback, file = null) => {
    return (dispatch, getState, {getFirebase}) => {
        dispatch({type: ADD_ITEM_REQUEST})

        let d = new Date()
        const {id, ...Item} = Itemm

        if (file !== null) {

            let typ = file.type;
            let sp = typ.split('/')
            let ex = sp[1]
            let n = Item.Barcode + "." + ex;
            const up = storage.ref(`images/${n}`).put(file);

            up.on('state_changed', (snap) => {

                }, error => toast.error(error),
                () => {
                    storage.ref('images').child(`${n}`).getDownloadURL().then(url => {
                        Item.ImageUrl = url

                        getFirebase().firestore().collection("items").doc(id).set({
                            ...Item,
                            Price: parseInt(Item.Price),
                            PriceUpdateAt: d,
                            UpdateAt: d,
                            ImageUrl: url
                        }, {merge: true})
                            .then((result) => {
                                dispatch({type: ADD_ITEM_SUCCESS});
                                goback();
                            })
                            .catch((error) => {
                                dispatch({type: ADD_ITEM_FAILIRE, error})
                            })

                    })


                })


        } else {
            getFirebase().firestore().collection("items").doc(id).set({
                ...Item,
                Price: parseInt(Item.Price),
                PriceUpdateAt: d,
                UpdateAt: d
            }, {merge: true})
                .then((result) => {
                    dispatch({type: ADD_ITEM_SUCCESS});
                    goback();
                })
                .catch((error) => {
                    dispatch({type: ADD_ITEM_FAILIRE, error})
                })
        }
    }
}
 

export const DeleteItem = (id = "", callback = null) => {
    return async (dispatch, getState,) => {
        try {

            const {raw} = selectKeyword(getState())

            const doc = raw?.find(item => item?.id === id);

            if (doc) {
                dispatch({type: ADD_ITEM_REQUEST})

                await firestore.runTransaction(transaction => {
                    const keywordRef = keywordsCollection.doc(doc?.docId)
                    const itemRef = itemsCollection.doc(id)
                    return transaction.get(keywordRef).then(doc => {

                        if (doc.exists) {
                            const keyWords = (doc.data()?.keyWords || [])?.filter(item => item?.id !== id);

                            transaction.update(keywordRef, {
                                keyWords
                            })

                            transaction.delete(itemRef)
                        }

                    })
                },)

                dispatch({type: DELETE_ITEM_SUCCESS, payload: id});

            }

            callback && callback()

        } catch (error) {
            dispatch({type: ADD_ITEM_FAILIRE, error})

        }
    }
}


export const SearchItemByName = (searchText) => {
    return async (dispatch, getState, {getFirebase}) => {
        try {
            dispatch({type: SEARCH_ITEM_REQUEST})
            const query = itemsCollection
                .where("SearchKeys", "array-contains", searchText.toUpperCase())
                .limit(30)

            const snap = await query.get();
            const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: docs})

            dispatch(setSnap({
                query,
                cursor: snap.docs[snap.docs.length - 1]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}


export const SearchItemByBarcode = (searchBarcode) => {
    return async (dispatch) => {
        try {
            dispatch({type: SEARCH_ITEM_REQUEST})
            const query = itemsCollection
                .where("Barcode", "==", searchBarcode)
                .limit(30)

            const snap = await query.get();
            const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: docs})

            dispatch(setSnap({
                query,
                cursor: snap.docs[snap.docs.length - 1]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}


export const SearchItemByCategory = (searchref) => {
    return async (dispatch) => {
        try {
            dispatch({type: SEARCH_ITEM_REQUEST})

            let query = itemsCollection
                .orderBy('UpdateAt', 'desc')
                .limit(30);

            if ('Id' in searchref) {
                query = query.where('Categorie.Id', '==', searchref?.Id);
            }

            if ('SubCategorie' in searchref) {
                query = query.where('Categorie.SubCategorie.Id', '==', searchref?.SubCategorie?.Id);
            }

            const snap = await query.get();
            const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: docs})

            dispatch(setSnap({
                query,
                cursor: snap.docs[snap.docs.length - 1]
            }))

        } catch (e) {
            console.error(e)
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})

        }
    }
}


export const SearchItemByProsoftRef = (searchref) => {
    return async (dispatch, getState, {getFirebase}) => {
        try {
            dispatch({type: SEARCH_ITEM_REQUEST})
            const query = itemsCollection
                .where("InternalId", "==", searchref)
                .limit(30)

            const snap = await query.get();
            const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: docs})

            dispatch(setSnap({
                query,
                cursor: snap.docs[snap.docs.length - 1]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}

export const SearchKeyWord = (newValue) => {
    return (dispatch, getState, {getFirebase}) => {
        dispatch({type: SEARCH_ITEM_REQUEST})
        getFirebase().firestore().collection("items")
            .doc(newValue.id)
            .get()
            .then(snapshot => {
                dispatch({
                    type: SEARCH_ITEM_SUCCESS,
                    payload: [{id: snapshot.id, ...snapshot.data()}]
                })
            })
            .catch((err) => {
                dispatch({type: SEARCH_ITEM_FAILIRE, error: err})
            })
    }
}


export const searchFilterNotValid = () => {
    return async (dispatch, getState, {getFirebase}) => {
        try {
            dispatch({type: SEARCH_ITEM_REQUEST})
            const query = itemsCollection
                .where("IsProductValidated", "==", false)
                .limit(30)

            const snap = await query.get();
            const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: docs})

            dispatch(setSnap({
                query,
                cursor: snap.docs[snap.docs.length - 1]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}

export const searchFilterValid = () => {
    return async (dispatch, getState, {getFirebase}) => {
        try {
            dispatch({type: SEARCH_ITEM_REQUEST})
            const query = itemsCollection
                .where("IsProductValidated", "==", true)
                .limit(30)

            const snap = await query.get();
            const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: docs})

            dispatch(setSnap({
                query,
                cursor: snap.docs[snap.docs.length - 1]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}




export const searchFilterNoCover = () => {
    return async (dispatch) => {
        try {
            dispatch({type: FILTER_NO_COVER})

            const nulledQuery = itemsCollection
                .where("ImageUrl", "==", null)
                .limit(30);

            const stringedQuery = itemsCollection
                .where("ImageUrl", "==", '')
                .limit(30)

            const nulledDocs = await nulledQuery.get();

            const stringedDocs = await stringedQuery.get();

            let list = []

            if (isNot(nulledDocs.empty)) {

                list = [
                    ...list,
                    ...nulledDocs.docs.map(doc => ({id: doc.id, ...doc.data()}))
                ]
            }

            if (isNot(stringedDocs.empty)) {
                list = [
                    ...list,
                    ...stringedDocs.docs.map(doc => ({id: doc.id, ...doc.data()}))
                ]
            }

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: uniqBy(list, 'id')})

            dispatch(setSnap({
                query: [
                    nulledQuery,
                    stringedQuery
                ],
                cursor: [
                    nulledDocs.docs[nulledDocs.docs.length - 1],
                    stringedDocs.docs[stringedDocs.docs.length - 1],
                ]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }

    }
}

export const searchFilterNoCategory = () => {
    return async (dispatch) => {
        try {
            dispatch({type: FILTER_NO_CATEGORY})

            const nulledQuery = itemsCollection
                .where("Categorie", "==", null)
                .limit(30);

            const stringedQuery = itemsCollection
                .where("Categorie", "==", '')
                .limit(30)

            const nulledDocs = await nulledQuery.get();

            const stringedDocs = await stringedQuery.get();

            let list = []

            if (isNot(nulledDocs.empty)) {

                list = [
                    ...list,
                    ...nulledDocs.docs.map(doc => ({id: doc.id, ...doc.data()}))
                ]
            }

            if (isNot(stringedDocs.empty)) {
                list = [
                    ...list,
                    ...stringedDocs.docs.map(doc => ({id: doc.id, ...doc.data()}))
                ]
            }

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: uniqBy(list, 'id')})

            dispatch(setSnap({
                query: [
                    nulledQuery,
                    stringedQuery
                ],
                cursor: [
                    nulledDocs.docs[nulledDocs.docs.length - 1],
                    stringedDocs.docs[stringedDocs.docs.length - 1],
                ]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}

export const searchFilterNoBarcode = () => {
    return async (dispatch) => {
        try {
            dispatch({type: FILTER_NO_BARCODE})

            const nulledQuery = itemsCollection
                .where("Barcode", "==", null)
                .limit(30);

            const stringedQuery = itemsCollection
                .where("Barcode", "==", '')
                .limit(30)

            const nulledDocs = await nulledQuery.get();

            const stringedDocs = await stringedQuery.get();

            let list = []

            if (isNot(nulledDocs.empty)) {

                list = [
                    ...list,
                    ...nulledDocs.docs.map(doc => ({id: doc.id, ...doc.data()}))
                ]
            }

            if (isNot(stringedDocs.empty)) {
                list = [
                    ...list,
                    ...stringedDocs.docs.map(doc => ({id: doc.id, ...doc.data()}))
                ]
            }

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: uniqBy(list, 'id')})

            dispatch(setSnap({
                query: [
                    nulledQuery,
                    stringedQuery
                ],
                cursor: [
                    nulledDocs.docs[nulledDocs.docs.length - 1],
                    stringedDocs.docs[stringedDocs.docs.length - 1],
                ]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}

export const searchFilterNoInternalId = () => {
    return async (dispatch) => {
        try {
            dispatch({type: FILTER_NO_INTERNAL_ID})

            const nulledQuery = itemsCollection
                .where("InternalId", "==", null)
                .limit(30);

            const stringedQuery = itemsCollection
                .where("InternalId", "==", '')
                .limit(30)

            const nulledDocs = await nulledQuery.get();

            const stringedDocs = await stringedQuery.get();


            let list = []

            if (isNot(nulledDocs.empty)) {

                list = [
                    ...list,
                    ...nulledDocs.docs.map(doc => ({id: doc.id, ...doc.data()}))
                ]
            }

            if (isNot(stringedDocs.empty)) {
                list = [
                    ...list,
                    ...stringedDocs.docs.map(doc => ({id: doc.id, ...doc.data()}))
                ]
            }

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: uniqBy(list, 'id')})


            dispatch(setSnap({
                query: [
                    nulledQuery,
                    stringedQuery
                ],
                cursor: [
                    nulledDocs.docs[nulledDocs.docs.length - 1],
                    stringedDocs.docs[stringedDocs.docs.length - 1],
                ]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}


export const searchFilterAll = () => {
    return async (dispatch) => {
        try {
            dispatch({type: SEARCH_ITEM_REQUEST})
            const query = itemsCollection
                .orderBy("UpdateAt", "desc")
                .limit(30)

            const snap = await query.get();
            const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: docs})

            dispatch(setSnap({
                query,
                cursor: snap.docs[snap.docs.length - 1]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}

export const getItemById = (id, callback = null) => {
    return async (dispatch) => {

        try {
            dispatch({type: SEARCH_ITEM_REQUEST})
            // console.log('id',id)
            const item = await firestore.collection("items").doc(id).get();
            // console.log('result', item.data())
            dispatch({type: SEARCH_ITEM_SUCCESS, payload: [{id: item.id, ...item.data()}]})

            if (callback) callback();

            dispatch(setSnap({
                query: null,
                cursor: null
            }))

        } catch (error) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: error})
        }
    }

}

export const loadMore = () => {
    return async (dispatch, getState) => {
        try {

            const {cursor, query} = selectProduct(getState());
            const {items} = selectItems(getState())

            if (cursor && query) {
                dispatch({type: SEARCH_ITEM_REQUEST})

                if (isArray(cursor) && isArray(query)) {
                    let result = [];
                    let cursors = [];

                    await Promise.all(query?.map(async (qy, idx) => {
                        if (cursor[idx]) {
                            const snap = await qy.startAfter(cursor[idx]).get();
                            const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))
                            result = [...result, ...docs]
                            cursors = [...cursors, {
                                idx,
                                cursor: snap.docs[snap.docs.length - 1]
                            }]
                        }
                    }))

                    dispatch({type: SEARCH_ITEM_SUCCESS, payload: result})

                    dispatch(setSnap({
                        query,
                        cursor: orderBy(cursors, 'idx', 'asc').map(({cursor}) => cursor)
                    }))

                } else {
                    const snap = await query.startAfter(cursor).get();
                    const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))

                    dispatch({type: SEARCH_ITEM_SUCCESS, payload: [...items, ...docs]})

                    dispatch(setSnap({
                        query,
                        cursor: snap.docs[snap.docs.length - 1]
                    }))
                }

            }

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
            console.error(e)
        }
    }
}